// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"5dddd2f6","239":"5cecd28a","453":"7a0cc671","455":"11f677b2","977":"91afa70f"}[chunkId] + ".chunk.js";
};